import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { DEFAULT_PAGE_TITLE } from '../utilties/StringConstants'
import ReactGA from "react-ga4"

const RouteWrapper = ({ component, location, allowExternalAuth, ua, title, gaPageTitle, ...rest }) => {
	useEffect(() => {
		if(title)
			document.title = title
		else
			document.title = DEFAULT_PAGE_TITLE
	}, [title])

	// useEffect(() => {
	// 	if(gaPageTitle) {
	// 		ReactGA.send({ hitType: "pageview", pageTitle: gaPageTitle });
	// 	}

	// }, [gaPageTitle])

	return (
		<Route
			{...rest}
			component={component}
		/>
	)
}

export default RouteWrapper